module.exports = __webpack_public_path__ + "img/tripe.7ff76a6e.svg";